import { UtilS } from '../../../Util/S/Function/module/UtilS.js';

const LABS_OPEN_DATE = 1737601200000; // '2025-01-23 12:00:00 정오에 자동으로 오픈됩니다.';

export const isLabsOpened = () => {
  if (UtilS.isProd()) {
    return LABS_OPEN_DATE < Date.now();
  }

  return true;
};

const NESS_FRAME_OPEN_DATE = 1764824400000; // '2025-12-04 14:00:00';

export const isNessFrameOpened = () => {
  if (UtilS.isProd()) {
    return NESS_FRAME_OPEN_DATE < Date.now();
  }

  return true;
};
